import { gql } from '@apollo/client'
import {
  FRAGMENT_CONTACT_CHORE,
  FRAGMENT_PATIENT_CHORE,
  FRAGMENT_PATIENT_PROFILE_CHORE,
} from '../../../../operations/fragments'

export const GET_PATIENTS_BY_DOCTOR = gql`
  query getPatients(
    $doctorIds: [String!]!
    $filterData: PatientFilter
    $paginationInput: PaginationInput
  ) {
    listPatientsForDoctor(
      doctorIds: $doctorIds
      filterData: $filterData
      paginationInput: $paginationInput
    ) {
      patients {
        id
        closedAt
        createdAt
        patient {
          id
          user {
            id
            email
          }
          ...patientChore
          birthDate
          weight
          height
          isDeletableForDoctor
        }
      }
      total
    }
  }
  ${FRAGMENT_PATIENT_CHORE}
`

export const GET_DOCTOR_PATIENT_PROFILE = gql`
  query getDoctorPatientProfile($patientId: String!) {
    getPatientProfile(patientId: $patientId) {
      ...patientProfileChore
      gender
      takenMedicines
      medicineIntolerance
      emergencyContacts {
        ...contactChore
      }
      entitleToInfoContacts {
        ...contactChore
      }
      emailSettings
      bloodType
      bloodTypeAttachmentEESZTId
      weight
      height
      isDeletableForDoctor
      doctors {
        id
        firstName
        lastName
        title
        professions {
          id
          code
          name
        }
      }
      user {
        id
        email
      }
    }
  }
  ${FRAGMENT_PATIENT_PROFILE_CHORE}
  ${FRAGMENT_CONTACT_CHORE}
`

export const DELETE_DOCTORS_OWN_PATIENT = gql`
  mutation deleteDoctorsOwnPatient($patientId: String!) {
    deleteDoctorsOwnPatient(patientId: $patientId) {
      id
      closedAt
    }
  }
`

export const DELETE_DOCTORS_OWN_PATIENTS = gql`
  mutation deleteDoctorsOwnPatients($patientIds: [String!]!) {
    deleteDoctorsOwnPatients(patientIds: $patientIds) {
      profile {
        patient {
          id
          ...patientChore
          birthDate
        }
      }
      success
    }
  }
  ${FRAGMENT_PATIENT_CHORE}
`

export const UPDATE_PATIENT_BLOOD_TYPE = gql`
  mutation updatePatientsBloodType(
    $patientId: String!
    $bloodType: BloodType!
    $bloodTypeAttachmentEESZTId: String
  ) {
    updatePatientsBloodType(
      patientId: $patientId
      bloodType: $bloodType
      bloodTypeAttachmentEESZTId: $bloodTypeAttachmentEESZTId
    ) {
      id
      bloodType
      bloodTypeAttachmentEESZTId
    }
  }
`

export const SEND_MESSAGE_TO_PATIENTS = gql`
  mutation sendMessageToPatients(
    $recipientUserIds: [String!]!
    $message: String!
    $alsoAsEmail: Boolean!
  ) {
    sendMessageToUsers(
      recipientUserIds: $recipientUserIds
      message: $message
      alsoAsEmail: $alsoAsEmail
    ) {
      success
      total
    }
  }
`
